import ArtworkDetail from './ArtworkDetail';

export default ArtworkDetail;
